<template>
  <div style="padding: 8px;">
    <dashboard-bar refreshButton />

    <div class="steps-area">
      <span class="idx-bold">Close the loop</span>

      <div class="steps">
        <div class="separator">
          <div class="step" :class="step === 1 ? 'active' : ''">
            <font-awesome-icon
              :icon="['fas', 'bullseye']"
              style="font-size: 24px; margin-right: 8px;"
            />
            <span>
              {{ $t('closetheloop.steps.selectAnswers') }}
            </span>
          </div>
        </div>

        <div class="separator">
          <div class="step" :class="step === 2 ? 'active' : ''">
            <font-awesome-icon
              :icon="['fas', 'clipboard']"
              style="font-size: 24px; margin-right: 8px;"
            />
            <span>
              {{ $t('closetheloop.steps.configTemplate') }}
            </span>
          </div>
        </div>

        <div class="separator">
          <div class="step" :class="step === 3 ? 'active' : ''">
            <font-awesome-icon
              :icon="['fas', 'paper-plane']"
              style="font-size: 24px; margin-right: 8px;"
            />
            <span>
              {{ $t('closetheloop.steps.reviewSubmission') }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-show="step === 1" class="wrapper mt-3">
      <select-answers v-model="stepOneInfo" />
    </div>

    <div v-show="step === 2" class="mt-3">
      <configure-template v-model="stepTwoInfo" />
    </div>

    <div v-if="step === 3" class="wrapper mt-3">
      <review-submission
        :stepOneInfo="stepOneInfo"
        :stepTwoInfo="stepTwoInfo"
      />
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate';
import { mapFields } from 'vuex-map-fields';
import dashboardBar from '@/components/molecules/dashboard-bar';
import SelectAnswers from './select-answers';
import ConfigureTemplate from './configure-template';
import ReviewSubmission from './review-submission';

export default {
  components: {
    dashboardBar,
    Paginate,
    SelectAnswers,
    ConfigureTemplate,
    ReviewSubmission,
  },

  data: () => ({
    userAuth: {},
    stepOneInfo: {
      ids: [],
      all: false,
      filtersSelected: {},
    },
    stepTwoInfo: {
      email: {
        subject: null,
        sender: null,
        html: null,
      },
      status: null,
      responsible: null,
    },
  }),

  computed: {
    ...mapFields('closetheloop', ['step']),
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.step = 1;
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.wrapper {
  background-color: $white;
  padding: 16px;
  border: 1px solid $gray-light;
  border-radius: 4px;
}

.steps-area {
  background-color: $white;
  padding: 8px 16px;
  border: 1px solid $gray-light;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .steps {
    display: flex;
    flex-direction: row;
    align-items: center;

    .separator {
      border-right: 1px solid #f1f1f1;
      padding: 8px;

      &:last-of-type {
        border-right: none;
      }
    }

    .step {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 8px 12px;
      color: #c1c1c1;
    }

    .active {
      color: black;
      border-bottom: 2px solid $primary;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/closetheloop/index.vue